import script from "./commission.vue?vue&type=script&setup=true&lang=js"
export * from "./commission.vue?vue&type=script&setup=true&lang=js"

import "./commission.vue?vue&type=style&index=0&id=0d268979&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\payment-system-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d268979"]])

export default __exports__